import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { NgbDatepickerModule, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonService } from '../../../Model/Common/common.service';
import { DeviceEssService } from '../../../Model/DeviceEss/device-ess.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { SessionService } from '../../../Util/Session/session.service';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-device-employee-attendance',
  standalone: true,
  imports: [DataTablesModule, CommonModule, FormsModule, RouterModule, NgSelectModule, NgbDatepickerModule, LoaderComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './device-employee-attendance.component.html',
  styleUrl: './device-employee-attendance.component.scss'
})
export class DeviceEmployeeAttendanceComponent {
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  FilterIndex = 0;
  AllData: any[] = [];
  Data: any[] = [];
  filter = {
    FromDate: null as any,
    Today: null as any,
    ToDate: null as any,
    DateType: 2,
    startOfMonth: null as any,
    endOfMonth: null as any,
  }

  Card = {
    TotalPunch: 0,
    TodayPunch: 0,
    SyncRate: 0 as any,
  }

  Devicefilter = {
    endPoint: "DeviceESS/employeeattendance",
    requestBody: {
      DeviceSerialNo: null,
      FromDate: null as any,
      ToDate: null as any,
      Type: 1,
      CompanyCode: null,
      EmployeeDetailsID: null as any,
      IsExcel: false,
    },
    httpMethod: "Post"
  }

  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private modalService: NgbModal,
    private deviceess: DeviceEssService,
    private route: ActivatedRoute,
    private session: SessionService,
    private utility: UtilityService,
    private dateFormat: CustomDateParserFormatter,
  ) {
    this.common.getPageRights();
    this.route.params.subscribe(params => this.Devicefilter.requestBody.EmployeeDetailsID = parseInt(params['id']));
    this.route.params.subscribe(params => this.Devicefilter.requestBody.DeviceSerialNo = params['sn']);
    this.Devicefilter.requestBody.CompanyCode = this.session.GetUserDetails().CompanyCode;
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.SelectDate('RegistrationDate', null, null);
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  FilterValidate(form: any) {
    if (form.valid) {
      this.Datesetfilter();
    }
    else {
      form.submitted = true;
    }
  }

  ESS_SiteWiseDeviceDetailsSelect(IsExcel = false) {
    this.isDisabled = true;
    this.Devicefilter.requestBody.FromDate = this.dateFormat.format(this.filter.FromDate);
    this.Devicefilter.requestBody.ToDate = this.dateFormat.format(this.filter.ToDate);
    this.Devicefilter.requestBody.IsExcel = IsExcel;
    this.deviceess.commonDeviceApi(this.Devicefilter).subscribe({
      next: (response) => {
        try {
          if ((!IsExcel && response && response.length > 0) || (IsExcel && response)) {
            if (IsExcel && response.success) {
              window.open(response.path, '_blank', 'noopener noreferrer');
            } else if (!IsExcel) {
              this.Card.TotalPunch = response.length;
              //this.Card.TodayPunch = [...new Set(response.map((e: any) => e.EmployeeDetailsId))].length;

              const todayString = new Date(this.filter.Today).toLocaleDateString('en-US', {
                month: 'short',
                day: '2-digit',
                year: 'numeric'
              }).replace(/,/g, ''); // "Dec 16 2025"

              // Filter records with today's date
              const todayRecords = response.map((e: any) => e.PunchDate).filter((dateStr: any) => {
                // Extract date part (before time)
                const datePart = dateStr.split('  ')[0];
                return datePart === todayString;
              });

              this.Card.TodayPunch = todayRecords.length;

              this.Card.SyncRate = ((response.filter((e: any) => e.IsSync).length * 100) / this.Card.TotalPunch).toFixed(2);

              this.AllData = response;
              this.Data = Object.values(response);

              if (this.AllData[0].ImagePath == null || this.AllData[0].ImagePath == '') {
                this.GetProfileImage(this.AllData[0].EmployeeDetailsID)
              }

              try {
                this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                  dtInstance.destroy();
                  this.dtTrigger.next(null);
                });
              } catch (e) { }
            }
          } else {
            if (!IsExcel && response.length == 0) {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = "Not Data available";
              modalRef.result.then((result: any) => { });
            } else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
            }
            this.ClearData();
          }
        } catch (e) {
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.filter.Today = response.Table[0].RegistrationDate;
          this.Datesetfilter();
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Datesetfilter() {
    const date = new Date(this.filter.Today);

    if (this.filter.DateType == 1) {
      this.filter.startOfMonth = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
      this.filter.endOfMonth = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
    } else if (this.filter.DateType == 2) {
      this.filter.startOfMonth = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      this.filter.endOfMonth = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    } else if (this.filter.DateType == 3) {
      this.filter.ToDate = this.filter.FromDate;
    } else if (this.filter.DateType == 5) {
      this.filter.startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
      this.filter.endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    }

    if (this.filter.DateType == 1 || this.filter.DateType == 2 || this.filter.DateType == 5) {
      this.filter.FromDate = this.dateFormat.parse(this.filter.startOfMonth.getDate() + " " + this.dateFormat.month[this.filter.startOfMonth.getMonth()] + " " + this.filter.startOfMonth.getFullYear());
      this.filter.ToDate = this.dateFormat.parse(this.filter.endOfMonth.getDate() + " " + this.dateFormat.month[this.filter.endOfMonth.getMonth()] + " " + this.filter.endOfMonth.getFullYear());
    }

    this.ESS_SiteWiseDeviceDetailsSelect();
  }

  ClearData() {
    this.AllData = [];
    this.Data = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
    this.Card = {
      TotalPunch: 0,
      TodayPunch: 0,
      SyncRate: 0,
    }
  }

  FilterData(index: number) {
    if (this.FilterIndex == index) {
      this.Data = Object.values(this.AllData);
      this.FilterIndex = 0;
    } else {
      this.FilterIndex = index;
      if (index == 1) {
        this.Data = Object.values(this.AllData);
      } else if (index == 2) {

        const todayString = new Date(this.filter.Today).toLocaleDateString('en-US', {
          month: 'short',
          day: '2-digit',
          year: 'numeric'
        }).replace(/,/g, ''); // "Dec 16 2025"

        // Filter records with today's date
        const todayRecords = this.AllData.map((e: any) => e.PunchDate).filter((dateStr: any) => {
          // Extract date part (before time)
          const datePart = dateStr.split('  ')[0];
          return datePart === todayString;
        });
        this.Data = Object.values(todayRecords);
      }
    }
    try {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } catch (e) { }
  }

  GetProfileImage(EmployeeDetailsID: number) {
    this.isDisabled = true;
    this.deviceess.commonDeviceApi({ endPoint: "DeviceESS/profileimage", requestBody: { CompanyCode: this.session.GetUserDetails().CompanyCode, DeviceSerialNo: this.Devicefilter.requestBody.DeviceSerialNo, EmployeeDetailsID: EmployeeDetailsID }, httpMethod: "Post" }).subscribe({
      next: (response) => {
        try {
          if (response.success && response.image != null && response.image != "") {
            this.AllData = this.AllData.map(e => ({ ...e, Base64: response.image }));
            this.Data = this.Data.map(e => ({ ...e, Base64: response.image }));
          }
        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  onNavigate(event: any) {
    this.filter.FromDate = {
      "year": event.next.year,
      "month": event.next.month,
      "day": 1
    }
  }
}
